<div class="min-h-screen bg-slate-50 flex items-center justify-center px-4 overflow-hidden relative">
    <div class="absolute top-0 -left-4 w-72 h-72 bg-red-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
    <div class="absolute top-0 -right-4 w-72 h-72 bg-indigo-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
    <div class="absolute -bottom-8 left-20 w-72 h-72 bg-pink-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
  
    <div class="max-w-md w-full text-center z-10">
      <div class="relative inline-block mb-8">
        <div class="absolute inset-0 bg-red-200 rounded-full blur-2xl opacity-50 animate-pulse"></div>
        <div class="relative bg-white p-6 rounded-full shadow-xl border border-red-50 to-white transform transition-transform hover:scale-110 duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 text-red-500 animate-bounce-slow" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
      </div>
  
      <h1 class="text-6xl font-extrabold text-slate-900 mb-2 tracking-tight">403</h1>
      <h2 class="text-2xl font-bold text-slate-800 mb-4">Access Denied</h2>
      <p class="text-slate-500 mb-8 leading-relaxed">
        Oops! It looks like you don't have the necessary permissions to access this page. 
        Please contact your <span class="font-semibold text-slate-700">Super Admin</span> if you believe this is a mistake.
      </p>
  
      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
        <button 
          (click)="goBack()"
          class="flex items-center justify-center px-6 py-3 border border-slate-200 text-slate-600 font-semibold rounded-xl hover:bg-slate-100 transition-all duration-200 w-full sm:w-auto">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd" />
          </svg>
          Go Back
        </button>
        
        <button 
          routerLink="/admin/dashboard"
          class="flex items-center justify-center px-8 py-3 bg-indigo-600 text-white font-semibold rounded-xl shadow-lg shadow-indigo-200 hover:bg-indigo-700 hover:shadow-indigo-300 transform transition-all hover:-translate-y-1 active:scale-95 duration-200 w-full sm:w-auto">
          Return to Dashboard
        </button>
      </div>
    </div>
  </div>